module.exports = __webpack_public_path__ + "static/media/celebration.964c56ba.gif";